module.exports = __webpack_public_path__ + "img/user.41eab9fe.jpg";